import { render } from "./Input.vue?vue&type=template&id=06a9383e"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=06a9383e&lang=css"
script.render = render

export default script